<template>
  <v-card
    class="mx-auto"
  >
    <v-card-text>
      <v-data-table dense v-if="!loading"
        :headers="tableHeader"
        :items="sensors"
        item-key="id"
        :items-per-page="pagination.itemsPerPage"
        :search="search"
        :custom-filter="filter"
        @click:row="clickDisambiguator"
      >
        <template v-slot:top>
        <v-row class="mx-auto mb-4">
        <!-- <v-text-field
          style="max-width: 400px;"
          outline 
          max=30
          v-model="search"
          label="Αναγνωριστικό"
          class="ml-0 mx-4"
        ></v-text-field> -->
        <!-- <v-text-field
          style="max-width: 400px;"
          outline 
          max=30
          v-model="campFilter"
          label="Περιοχή Ευθύνης"
          class="ml-4 mx-4"
        ></v-text-field> -->
        <CampPicker :camps="campFilter" ref="campPicker"/>

        </v-row>

        <v-row class="mx-auto mb-6">
          <v-btn
            color="blue"
            class="text-left"
            @click="load">
            ΑΝΑΖΗΤΗΣΗ
          </v-btn>

          <v-dialog
            v-model="sensorClearDialog"
            v-if="canClear"
            width="500"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="orange"
                dark
                v-bind="attrs"
                v-on="on"
                class="text-left ml-2"
                :disabled="selSensorId === null || selSensorId === undefined || selSensorId.length === 0"
              >
                Εκκαθ. {{ selSensorId ? selSensorId.substring(0,6)+"..." : "Αισθητήρα" }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                Επιβεβαίωση
              </v-card-title>

              <v-card-text>
                Η εκκαθάριση όλων των συμβάντων για έναν αισθητήρα είναι μη-αναστρέψιμη.
                Γράψτε {{ randConfirmation }} για να επιβεβαιώσετε την εκκαθάριση του αισθητήρα {{ selSensorId }}:

                  <v-text-field
                    style="max-width: 200px;"
                    outline 
                    v-model="randConfirmInput"
                    :label="randConfirmation"
                  ></v-text-field>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="orange"
                  @click="clearSensor"
                  :disabled="randConfirmInput !== randConfirmation"
                >
                  Ναι, εκκαθάριση
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn
            color="green"
            class="text-left ml-2"
            @click="downloadSensors">
            ΚΑΤΕΒΑΣΜΑ
          </v-btn>
        </v-row>
      </template>

      </v-data-table>

    </v-card-text>

  </v-card>
</template>

<script>
import CampPicker from '@/components/CampPicker.vue'

export default {
  name: 'SensorManagement',
  components: {
    CampPicker
  },
  async mounted() {
    const u = this.$store.state.user
    if (!u.isAdmin) {
      this.campFilter = u.camps
      this.$refs.campPicker.selectedCamps = this.campFilter
    } else {
      this.canClear = true
    }

    if (!(u.camps && u.camps.length > 0)) {
      return
    }

    await this.load()
  },
  data: () => {
    return {
      search: '',
      loading: false,
      campFilter: [],
      error: "",
      sensors: [],
      selSensorId: "",
      sensorClearDialog: false,
      clicks: 0,
      clickDelay: 200,
      timer: null,
      canClear: false,
      randConfLen: 4,
      randConfirmInput: "",
      pagination: {
        itemsPerPage: 100
      },
      displayNames: {
        //'id': 'Αναγνωριστικό (id)',
        'description': 'Περιγραφή',
        //'authkey': 'Κλειδί',
        'camp': 'Περιοχή Ευθύνης',
        'orientations': 'Κατευθύνσεις',
        'latitude': 'Γεω. Πλάτος (Latitude)',
        'longitude': 'Γεω. Μήκος (Longitude)'
      }
    }
  },
  computed: {
    tableHeader() {
      const self = this 
      if (!this.sensors || this.sensors.length == 0) {
        return []
      }
      
      return Object.keys(this.sensors[0])
          .filter(x => Object.keys(self.displayNames).includes(x.toLowerCase()))
          .map(function(x){ 
            return {
              text: self.displayNames[x.toLowerCase()],
              align: 'start',
              sortable: true,
              value: x
            }
          }
          )
    },
    randConfirmation() {
      let pool = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
      let ret = ""
      for (var i=0; i<this.randConfLen; i++) {
        ret += pool.charAt(Math.floor(Math.random() * pool.length))
      }
      return ret
    }
  },
  methods: {
    clickDisambiguator: function(event){
      this.clicks++
      if(this.clicks === 1) {
        var self = this
        this.timer = setTimeout(function() {
          self.selSensorId = event.id
          self.clicks = 0
        }, this.clickDelay)
      } else {
          clearTimeout(this.timer);  
          this.goSensorDetails(event)
          this.clicks = 0
      }
    },
    goSensorDetails(value) {
      this.$router.push(`/sensors/${value.id}`)
    },
    async downloadSensors () {
      var q = {}

      const ref_campPicker = this.$refs.campPicker
      if (ref_campPicker.selectedCamps.length > 0) {
        q.camp = this.$refs.campPicker.selectedCamps[0]
      }

      try{
        const response = await this.$axios.get('/sensors/export', {params: {...q} })
        const csvContent = "data:text/csv;charset=utf-8," + response.data

        var encodedUri = encodeURI(csvContent)

        var link = document.createElement("a")
        link.hidden = true
        link.setAttribute("href", encodedUri)
        link.setAttribute("download", "sensors.csv")
        document.body.appendChild(link);
        link.click()

      } catch (e) {
        console.log(e.response)
        this.error = e.response.data 
      }
    },
    async clearSensor() {
      try{
        const query = { sensorId: this.selSensorId}
        const response = await this.$axios.delete('/sensorEvents/clearSensor', { params:{...query}})
        console.log(`Clearing events for sensor: ${this.selSensorId}`)
        console.log(response)
        this.selSensorId = ""
        this.randConfirmInput = ""
      } catch (e) {
        console.log(e.response)
        this.error = e.response.data
      }
      this.sensorClearDialog = false
    },
    async load() {
      this.loading = true

      this.selSensorId = ""
      this.randConfirmInput = ""

      var q = {}
      this.sensors = []
      const ref_campPicker = this.$refs.campPicker
      for (var selCamp of ref_campPicker.selectedCamps) {
        try{
          q.camp = selCamp
          const response = await this.$axios.get('/sensors', { params: {...q} })
          this.sensors = this.sensors.concat(response.data)
        } catch (e) {
          console.log(e.response)
          this.error = e.response.data 
        }
      }

      this.loading = false
    },
    /* eslint-disable */
    filter (value, search, _item) {  // _item unused var
    /* eslint-enable */
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLowerCase().indexOf(search) !== -1
    },
  }
}
</script>
